module.exports = __webpack_public_path__ + "static/img/px_3.d4b0378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/px_3.jpg
// module id = KYkr
// module chunks = 1